<template>
    <NuxtLayout name="malt-base-layout">
        <LazyNavbar is-funnel-mode />
        <slot />
        <LazyFooter />
    </NuxtLayout>
</template>

<script setup lang="ts">
    import {LazyNavbar, LazyFooter, NuxtLayout} from '#components';
</script>
